import src from "IMAGE";
export default { src, width: 8, height: 6, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
